export const channelTypeMapping: {
  [key: string]: { name: string; index: number };
} = {
  clinical: { name: 'Clinical Chat', index: 0 },
  support: { name: 'Customer Support', index: 1 },
  shipping: { name: 'Shipping Support', index: 2 },
  billing: { name: 'Billing Support', index: 3 }
};

export const REQUIRED_CHANNEL_TYPES = ['clinical'];
